'use client';

import RichText from "@/components/RichText";
import { ComponentProps, Fragment, useEffect, useRef, useState } from 'react';
import { pseudoI18n } from "@/i18n/pseudoI18n";
import { ChevronDown } from "lucide-react";
import { clsx } from "clsx";
import { Product } from "@/payload-types";

const CONTENT_MAX_HEIGHT = 500;

export default function ProductInfoDescription( props: {description: Product['description']} ) {
  const { description } = props;

  const [ contentHeight, setContentHeight ] = useState( 0 );
  const [ expanded, setExpanded ] = useState( false );
  const contentRef = useRef<HTMLDivElement>( null );

  const toggleExpand = () => setExpanded(!expanded);

  const { t } = pseudoI18n();

  useEffect( () => {
    const resizeHandler = () => setContentHeight( contentRef.current?.scrollHeight || 0 );

    setTimeout(resizeHandler, 1000);
    window.addEventListener( 'resize', resizeHandler );
    return () => window.removeEventListener( 'resize', resizeHandler );
  }, [] );

  if (!description) {
    return <i>{t('Coming soon')}</i>;
  }

  return (
    <div>
      <div className='overflow-hidden transition-all duration-500' ref={ contentRef } style={{maxHeight: expanded ? `${contentHeight}px` : `${CONTENT_MAX_HEIGHT}px` }} >
        <RichText content={ description }/>
      </div>
      { contentHeight > CONTENT_MAX_HEIGHT && (
        <div className={clsx(
          'relative transition-all duration-500 w-full py-8 bg-gradient-to-b from-transparent to-white to-30%',
          expanded ? 'translate-y-0' : '-translate-y-1/3'
        )}>
          <Fragment>
            <div className={clsx(
              'absolute bottom-0 h-40 bg-gradient-to-b from-white/0 to-white',
              expanded && 'opacity-0 invisible pointer-events-none'
            )}></div>
            <button className='font-semibold flex mx-auto items-center cursor-pointer gap-1 text-secondary'
                    onClick={ toggleExpand }>
              { expanded ? t( 'See less' ) : t( 'See more' ) }
              <ChevronDown width={ 16 } className={ clsx( expanded && '-rotate-180' ) } />
            </button>
          </Fragment>
        </div>
      ) }
    </div>
  );
}
